document.addEventListener("DOMContentLoaded", function () {

  /* ======================================================
     HARD GUARD: ONLY RUN ON FILTERABLE PRODUCT LIST PAGES
     ====================================================== */

  const hasProductCards = document.querySelector(".product-card");
  const hasFilterUI =
    document.querySelector(".filter-pill") ||
    document.getElementById("priceMinSlider") ||
    document.getElementById("sidebarLiveSearch");

  //  If this is NOT a collection / filterable page, STOP
  if (!hasProductCards || !hasFilterUI) {
    return;
  }

  /* ======================================================
     FILTER HELPERS
     ====================================================== */

  function getActiveFilterPills() {
    return Array.from(document.querySelectorAll(".filter-pill.active"))
      .map(p => p.dataset.filter);
  }

  function getPriceRange() {
    const minSlider = document.getElementById("priceMinSlider");
    const maxSlider = document.getElementById("priceMaxSlider");
    const min = parseFloat(minSlider?.value || 0);
    const max = parseFloat(maxSlider?.value || 999999);
    return { min, max };
  }

  function matchesPrice(card, min, max) {
    const price = parseFloat(card.dataset.price || 0);
    return price >= min && price <= max;
  }

  function matchesTags(card, tags) {
    if (tags.length === 0) return true;
    const productTags = card.dataset.tags || "";
    return tags.every(t => productTags.includes(t));
  }

  function matchesSearch(card, term) {
    if (!term) return true;
    const title =
      card.querySelector(".product-card_name")?.innerText.toLowerCase() || "";
    return title.includes(term);
  }

  /* ======================================================
     APPLY FILTERS
     ====================================================== */

  function applyFilters() {
    const tags = getActiveFilterPills();
    const { min, max } = getPriceRange();
    const search = (
      document.getElementById("sidebarLiveSearch")?.value || ""
    ).toLowerCase().trim();

    document.querySelectorAll(".product-card").forEach(card => {
      const visible =
        matchesTags(card, tags) &&
        matchesPrice(card, min, max) &&
        matchesSearch(card, search);

      card.style.display = visible ? "" : "none";
    });
  }

  /* ======================================================
     PRICE SLIDER SYNC
     ====================================================== */

  const minSlider = document.getElementById("priceMinSlider");
  const maxSlider = document.getElementById("priceMaxSlider");
  const minLabel  = document.getElementById("priceMinDisplay");
  const maxLabel  = document.getElementById("priceMaxDisplay");

  function syncLabels() {
    if (!minSlider || !maxSlider || !minLabel || !maxLabel) return;

    let minVal = parseFloat(minSlider.value);
    let maxVal = parseFloat(maxSlider.value);

    if (minVal > maxVal) {
      [minVal, maxVal] = [maxVal, minVal];
      minSlider.value = minVal;
      maxSlider.value = maxVal;
    }

    minLabel.innerText = "$" + minVal;
    maxLabel.innerText = "$" + maxVal;
  }

  if (minSlider && maxSlider && minLabel && maxLabel) {
    minSlider.addEventListener("input", syncLabels);
    maxSlider.addEventListener("input", syncLabels);
    syncLabels();
  }

  /* ======================================================
     EVENTS
     ====================================================== */

  document
    .getElementById("applyPriceRange")
    ?.addEventListener("click", applyFilters);

  document.querySelectorAll(".filter-pill").forEach(pill => {
    pill.setAttribute("aria-pressed", pill.classList.contains("active") ? "true" : "false");

    pill.addEventListener("click", function () {
      this.classList.toggle("active");
      this.setAttribute("aria-pressed", this.classList.contains("active") ? "true" : "false");
      applyFilters();
    });
  });

  document
    .getElementById("sidebarLiveSearch")
    ?.addEventListener("input", applyFilters);

  document
    .getElementById("clearAllFilters")
    ?.addEventListener("click", function () {
      document
        .querySelectorAll(".filter-pill.active")
        .forEach(p => {
          p.classList.remove("active");
          p.setAttribute("aria-pressed", "false");
        });

      if (minSlider && maxSlider && minLabel && maxLabel) {
        minSlider.value = 0;
        maxSlider.value = 2000;
        minLabel.innerText = "$0";
        maxLabel.innerText = "$2000";
      }

      const searchEl = document.getElementById("sidebarLiveSearch");
      if (searchEl) searchEl.value = "";

      applyFilters();
    });
  /* ======================================================
     FILTER GROUP TOGGLES
     ====================================================== */

  let disclosureIndex = 0;

  function initFilterDisclosure(button) {
    const content = button.nextElementSibling;
    if (!content) return;

    if (!content.id) {
      disclosureIndex += 1;
      content.id = `filter-disclosure-${disclosureIndex}`;
    }

    button.setAttribute("aria-controls", content.id);
    button.setAttribute("aria-expanded", content.style.display === "block" ? "true" : "false");

    button.addEventListener("click", () => {
      const content = button.nextElementSibling;
      if (!content) return;

      const isExpanded = content.style.display !== "block";
      content.style.display = isExpanded ? "block" : "none";
      button.setAttribute("aria-expanded", isExpanded ? "true" : "false");
    });
  }

  document.querySelectorAll(".filter-parent-toggle").forEach(initFilterDisclosure);
  document.querySelectorAll(".filter-toggle").forEach(initFilterDisclosure);

  /* ======================================================
     INITIAL RUN
     ====================================================== */

  applyFilters();
});
/* Legacy Chromium product-image overrides removed.
   Product gallery sizing now lives in custom.css and product template markup. */

document.addEventListener("DOMContentLoaded", function () {
  const searchButtons = document.querySelectorAll(".js-mobile-bar-open");

  if (!searchButtons.length) {
    return;
  }

  const openSearchDrawer = function () {
    if (window.AT && AT.searchDrawer) {
      if (AT.searchDrawer.loaded) {
        AT.searchDrawer.open();
        return true;
      }

      if (typeof AT.searchDrawer.load === "function") {
        AT.searchDrawer.load().then(function () {
          if (AT.searchDrawer && typeof AT.searchDrawer.open === "function") {
            AT.searchDrawer.open();
          }
        });
        return true;
      }
    }

    return false;
  };

  searchButtons.forEach(function (button) {
    button.addEventListener("click", function (event) {
      const fallbackUrl = button.getAttribute("data-search-fallback-url") || "/search";

      if (openSearchDrawer()) {
        event.preventDefault();
        return;
      }

      window.location.href = fallbackUrl;
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const calculatorRoutes = {
    "/pages/fitment-calculators": "hp-calc-page hp-calc-hub",
    "/pages/offset-calculator": "hp-calc-page hp-calc-offset",
    "/pages/simple_tire_calculator": "hp-calc-page hp-calc-simple-tire",
    "/pages/tire-size-converter": "hp-calc-page hp-calc-tire-converter",
    "/pages/tire-size-calculator": "hp-calc-page hp-calc-tire-size",
    "/pages/alignment-calculator": "hp-calc-page hp-calc-geometry hp-calc-alignment",
    "/pages/control-arm-axle-rotation-caster-calculator": "hp-calc-page hp-calc-geometry hp-calc-control-arm",
    "/pages/looks-straight-enough-toe-checking-wizard-beta": "hp-calc-page hp-calc-geometry hp-calc-toe",
    "/pages/hurrey-s-tow-load-support-calculator-beta": "hp-calc-page hp-calc-system hp-calc-tow",
    "/pages/winch-guide-beta": "hp-calc-page hp-calc-system hp-calc-winch",
    "/pages/automotive-battery-guide-beta": "hp-calc-page hp-calc-system hp-calc-battery",
    "/pages/automotive-wiring-size-tool-beta": "hp-calc-page hp-calc-system hp-calc-wire",
    "/pages/vehicle-wheel-tire-fitment-reference-hurrey-s-performance": "hp-calc-page hp-calc-reference hp-calc-fitment-library",
    "/pages/bolt-pattern-center-bore-factory-wheel-spec-reference": "hp-calc-page hp-calc-reference hp-calc-bolt-pattern",
    "/pages/lift-kit-height-guide": "hp-calc-page hp-calc-reference hp-calc-lift-guide",
    "/pages/hurrey-s-tap-drill-torque-thread-tool-beta": "hp-calc-page hp-calc-reference hp-calc-thread"
  };
  const routeClass = calculatorRoutes[window.location.pathname || ""];
  if (routeClass) {
    document.body.className = (document.body.className + " " + routeClass).trim();
  }

  function rescueFitmentHub() {
    if ((window.location.pathname || "") !== "/pages/fitment-calculators") return;

    const hub = document.querySelector("#hurreys-fitment-tool-wrapper, .hpc-wic-portal");
    if (!hub) return;

    document.documentElement.classList.add("hp-fitment-hub-rescued");
    document.body.classList.add("hp-fitment-hub-rescued");

    let node = hub;
    while (node && node !== document.body) {
      if (
        node.id === "main-content" ||
        node.id === "col-main" ||
        node.classList.contains("shopify-section") ||
        node.classList.contains("container") ||
        node.classList.contains("page") ||
        node.classList.contains("page_wrapper") ||
        node.classList.contains("page-content")
      ) {
        try {
          node.hidden = false;
          node.removeAttribute("hidden");
        } catch (error) {}
        node.classList.add("hp-fitment-rescue-visible");
        node.style.setProperty("display", "block", "important");
        node.style.setProperty("visibility", "visible", "important");
        node.style.setProperty("opacity", "1", "important");
        node.style.setProperty("width", "100%", "important");
        node.style.setProperty("max-width", "none", "important");
        node.style.setProperty("height", "auto", "important");
        node.style.setProperty("min-height", "0", "important");
        node.style.setProperty("overflow", "visible", "important");
      }
      node = node.parentElement;
    }

    hub.style.setProperty("display", "block", "important");
    hub.style.setProperty("visibility", "visible", "important");
    hub.style.setProperty("width", "100%", "important");
    hub.style.setProperty("height", "auto", "important");
    hub.style.setProperty("overflow", "visible", "important");
  }

  rescueFitmentHub();
  window.setTimeout(rescueFitmentHub, 250);
  window.setTimeout(rescueFitmentHub, 900);
  window.setTimeout(rescueFitmentHub, 1800);
});

document.addEventListener("DOMContentLoaded", function () {
  // V56: local geo nudge disabled; it was competing with service/status quote flows.
  return;

  const dismissKey = "hpLocalNudgeDismissedAt";
  const shownKey = "hpLocalNudgeShown";
  const shopLat = 40.2163;
  const shopLng = -74.6822;
  const maxMiles = 90;
  const dismissDays = 14;
  const path = window.location.pathname || "/";
  const isProductRoute = /^\/products\/[^/?#]+/.test(path);
  const isHomeRoute = path === "/" || path === "";
  const quietRoutes = [
    /^\/cart\/?$/,
    /^\/checkouts?/,
    /^\/pages\/contact\/?$/,
    /^\/pages\/search\/?$/,
    /^\/search\/?$/,
    /^\/pages\/services-hub\/?$/,
    /^\/pages\/status-portal\/?$/,
    /^\/pages\/fitment-calculators\/?$/,
    /^\/pages\/offset-calculator\/?$/,
    /^\/pages\/simple_tire_calculator\/?$/,
    /^\/pages\/tire-size/,
    /^\/pages\/alignment-calculator\/?$/,
    /^\/pages\/control-arm-axle-rotation-caster-calculator\/?$/,
    /^\/pages\/looks-straight-enough-toe-checking-wizard-beta\/?$/,
    /^\/pages\/hurrey-s-tow-load-support-calculator-beta\/?$/,
    /^\/pages\/winch-guide-beta\/?$/,
    /^\/pages\/automotive-battery-guide-beta\/?$/,
    /^\/pages\/automotive-wiring-size-tool-beta\/?$/,
    /^\/pages\/vehicle-wheel-tire-fitment-reference-hurrey-s-performance\/?$/,
    /^\/pages\/bolt-pattern-center-bore-factory-wheel-spec-reference\/?$/,
    /^\/pages\/lift-kit-height-guide\/?$/,
    /^\/pages\/hurrey-s-tap-drill-torque-thread-tool-beta\/?$/
  ];

  if (!window.fetch || !window.localStorage || !window.sessionStorage) return;
  if (quietRoutes.some(function (pattern) { return pattern.test(path); })) return;
  if (sessionStorage.getItem(shownKey) === "1") return;

  const dismissedAt = Number(localStorage.getItem(dismissKey) || 0);
  if (dismissedAt && Date.now() - dismissedAt < dismissDays * 24 * 60 * 60 * 1000) {
    return;
  }

  function toRadians(value) {
    return value * Math.PI / 180;
  }

  function milesBetween(lat1, lng1, lat2, lng2) {
    const earthMiles = 3958.8;
    const dLat = toRadians(lat2 - lat1);
    const dLng = toRadians(lng2 - lng1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return earthMiles * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function dismiss(card) {
    localStorage.setItem(dismissKey, String(Date.now()));
    card.classList.remove("is-visible");
    window.setTimeout(function () {
      card.remove();
    }, 260);
  }

  function showLocalNudge() {
    if (document.querySelector(".hp-local-nudge")) return;

    const card = document.createElement("section");
    card.className = "hp-local-nudge";
    if (isProductRoute) {
      card.classList.add("hp-local-nudge--product");
    } else {
      card.classList.add("hp-local-nudge--compact");
    }
    card.setAttribute("aria-label", "Local shop help");
    card.innerHTML = [
      '<button type="button" class="hp-local-nudge__close" aria-label="Dismiss local shop message">&times;</button>',
      '<p class="hp-local-nudge__kicker">Local shop support</p>',
      '<strong>Near Hamilton, NJ?</strong>',
      '<p>Get fitment help before you order, schedule install work, or swing by the shop.</p>',
      '<div class="hp-local-nudge__actions">',
      '<a href="tel:16092494921">Call</a>',
      '<a href="/pages/services-hub">Service</a>',
      '<a href="https://www.google.com/maps/dir/?api=1&destination=109%20Flock%20Road%2C%20Hamilton%2C%20NJ%2008619" target="_blank" rel="noopener noreferrer">Directions</a>',
      '</div>'
    ].join("");

    card.querySelector(".hp-local-nudge__close").addEventListener("click", function () {
      dismiss(card);
    });

    card.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        localStorage.setItem(dismissKey, String(Date.now()));
      });
    });

    document.body.appendChild(card);
    sessionStorage.setItem(shownKey, "1");
    window.setTimeout(function () {
      card.classList.add("is-visible");
    }, 80);
  }

  fetch("https://ipapi.co/json/", { cache: "no-store" })
    .then(function (response) {
      if (!response.ok) throw new Error("Location lookup unavailable");
      return response.json();
    })
    .then(function (data) {
      const country = String(data.country_code || data.country || "").toUpperCase();
      const lat = Number(data.latitude);
      const lng = Number(data.longitude);

      if (country && country !== "US") return;
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
      if (milesBetween(shopLat, shopLng, lat, lng) > maxMiles) return;

      const delay = isProductRoute ? 6500 : (isHomeRoute ? 12000 : 9000);
      window.setTimeout(showLocalNudge, delay);
    })
    .catch(function () {
      return null;
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const mobileHeader = document.getElementById("header-mobile-container");

  if (!mobileHeader) {
    return;
  }

  const drawerShell = mobileHeader.querySelector(".header-mobile_drawer");
  const mainDrawer = document.getElementById("mobile-drawer-main");
  const subDrawer = document.getElementById("mobile-drawer-sub");
  let activeTrigger = null;

  if (!drawerShell || !mainDrawer) {
    return;
  }

  function getSourceRoot(id) {
    const node = document.getElementById(id);

    if (!node) {
      return null;
    }

    return node.content || node;
  }

  function findLazySource(containerId, targetId) {
    const root = getSourceRoot(containerId);

    if (!root || !targetId) {
      return null;
    }

    return root.querySelector('[data-id="' + targetId + '"]');
  }

  function enhanceDrawerControls(scope) {
    if (!scope) {
      return;
    }

    scope.querySelectorAll(".js-toggle-menu").forEach(function (button) {
      button.setAttribute("role", "button");
      button.setAttribute("tabindex", "0");

      if (!button.hasAttribute("aria-expanded")) {
        button.setAttribute("aria-expanded", "false");
      }
    });

    scope.querySelectorAll(".js-btn-close").forEach(function (button) {
      button.setAttribute("role", "button");
      button.setAttribute("tabindex", "0");

      if (!button.hasAttribute("aria-label")) {
        button.setAttribute("aria-label", "Close menu");
      }
    });
  }

  function hydrateDrawer(drawer) {
    if (!drawer || drawer.classList.contains("menu-lazy-loaded")) {
      return;
    }

    const template = drawer.querySelector("template");
    const content = template && template.content && template.content.firstElementChild;

    if (!content) {
      return;
    }

    drawer.innerHTML = content.outerHTML;
    drawer.classList.add("menu-lazy-loaded");
    enhanceDrawerControls(drawer);
  }

  function hydratePanel(panel) {
    if (!panel || panel.dataset.hurreysLoaded === "true") {
      return;
    }

    const targetId = panel.dataset.targetId;
    const lazyResource = panel.dataset.lazyResource;
    let source = null;

    if (lazyResource === "mega-menu") {
      source =
        findLazySource("main-mega-menu", targetId) ||
        findLazySource("sub-mega-menu", targetId);
    } else {
      source = findLazySource("header-menu-sublinks", targetId);
    }

    if (!source) {
      return;
    }

    panel.innerHTML = source.innerHTML;
    panel.dataset.hurreysLoaded = "true";
    enhanceDrawerControls(panel);
  }

  function setScrollLocked(isLocked) {
    document.body.classList.toggle("overflow-hidden", isLocked);

    if (window.AT) {
      try {
        if (isLocked && typeof AT.disableScroll === "function") {
          AT.disableScroll();
        } else if (!isLocked && typeof AT.enableScroll === "function") {
          AT.enableScroll();
        }
      } catch (error) {
        console.warn("Mobile nav scroll lock skipped:", error);
      }
    }
  }

  function setTriggerState(isOpen) {
    mobileHeader
      .querySelectorAll(".js-main-drawer-open-button, .js-sub-drawer-open-button")
      .forEach(function (button) {
        button.setAttribute("aria-expanded", isOpen ? "true" : "false");
      });
  }

  function focusSafely(element) {
    if (!element || typeof element.focus !== "function") {
      return;
    }

    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
  }

  function openDrawer(drawer, trigger) {
    if (!drawer) {
      return;
    }

    hydrateDrawer(drawer);

    if (!drawer.classList.contains("menu-lazy-loaded")) {
      return;
    }

    activeTrigger = trigger || null;
    drawerShell.classList.add("is-open");
    drawer.classList.add("is-open");
    setTriggerState(true);
    setScrollLocked(true);

    const closeButton = drawer.querySelector(".js-btn-close");

    if (closeButton) {
      window.setTimeout(function () {
        focusSafely(closeButton);
      }, 50);
    }
  }

  function closeDrawer() {
    drawerShell.classList.remove("is-open");
    drawerShell
      .querySelectorAll(".header-mobile__item.is-open, .dropdown-menu.is-open")
      .forEach(function (panel) {
        panel.classList.remove("is-open");
      });

    setTriggerState(false);
    setScrollLocked(false);

    if (activeTrigger) {
      focusSafely(activeTrigger);
    }

    activeTrigger = null;
  }

  document.addEventListener(
    "click",
    function (event) {
      const trigger = event.target.closest(
        ".js-main-drawer-open-button, .js-sub-drawer-open-button"
      );

      if (!trigger || !mobileHeader.contains(trigger)) {
        return;
      }

      const drawer = trigger.classList.contains("js-sub-drawer-open-button")
        ? subDrawer
        : mainDrawer;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      openDrawer(drawer, trigger);
    },
    true
  );

  drawerShell.addEventListener(
    "click",
    function (event) {
      const closeButton = event.target.closest(".js-btn-close");

      if (closeButton && drawerShell.contains(closeButton)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        closeDrawer();
        return;
      }

      const toggle = event.target.closest(".js-toggle-menu");

      if (!toggle || !drawerShell.contains(toggle)) {
        return;
      }

      const drawer = toggle.closest(".header-mobile__item");
      const targetId = toggle.dataset.target;
      const role = toggle.dataset.role;
      const target = drawer && targetId ? drawer.querySelector("#" + targetId) : null;

      if (!target) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (role === "next") {
        hydratePanel(target);
        target.classList.add("is-open");
        toggle.setAttribute("aria-expanded", "true");
      } else if (role === "previous") {
        target.classList.remove("is-open");
        toggle.setAttribute("aria-expanded", "false");
      }
    },
    true
  );

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && drawerShell.classList.contains("is-open")) {
      closeDrawer();
    }

    if (event.key !== "Enter" && event.key !== " ") {
      return;
    }

    const keyboardButton = event.target.closest(".js-toggle-menu, .js-btn-close");

    if (keyboardButton && drawerShell.contains(keyboardButton)) {
      event.preventDefault();
      keyboardButton.click();
    }
  });
});
